/**
 * Custom Main JavaScript
 */

'use strict';

document.addEventListener('DOMContentLoaded', function domLoaded() {
  footerJumpHandler();
  cartBackButtonFix();
});


function footerJumpHandler() {

    // Patch autoscrollhandler to respect footer jump flag
    const originalAutoscrollHandler = window.autoscrollhandler;
    window.autoscrollhandler = function autoscrollhandlerHandle() {
      if (window._footerJumping) return;
      originalAutoscrollHandler();
    };

    // Use event delegation + capture to intercept before theme handlers
    document.addEventListener('click', function handleFooterLinkClick(e) {
      const link = e.target.closest('a[href*="#shopify-section-footer-template"]');
      if (!link) return;

      const backToTop = document.querySelector('.tt-back-to-top');
      if (backToTop) backToTop.classList.add('tt-show');

      e.preventDefault();
      e.stopPropagation();

      // Close mobile menu if open
      const mmClose = document.querySelector('.mm-close');
      if (mmClose) mmClose.click();

      // Block infinite scroll during jump
      window._footerJumping = true;

      // Open Shops/Retail accordion if collapsed (mobile locations fix)
      const targetAccordion = Array.from(document.querySelectorAll('.tt-collapse-title'))
        .find(el => /PRODAVNICE|SHOPS|RETAIL/.test(el.textContent.trim()));
      if (targetAccordion && !targetAccordion.classList.contains('tt-open')) {
        targetAccordion.classList.add('tt-open');
      }

      // Scroll to accordion content or footer as fallback
      setTimeout(function scrollToSection() {
        const target = (targetAccordion?.nextElementSibling ?? targetAccordion)
          ?? document.getElementById('shopify-section-footer-template');
        if (!target) return;
        if (target.id === 'shopify-section-footer-template') {
          target.scrollIntoView({ behavior: 'instant' });
        } else {
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.pageYOffset - 200,
            behavior: 'instant'
          });
        }
      }, 100);

      // Unblock infinite scroll after jump completes
      setTimeout(function unblockInfiniteScroll() {
        window._footerJumping = false;
      }, 800);

    }, true); // true = capture phase

    // =========================================================
    // Translates dynamically loaded content inside the quickview
    // modal that Weglot does not catch automatically.
    // Targets: .tt-title, .qv_vendor, .qv_type
    // =========================================================

    const modal = document.getElementById('ModalquickView');

    // Store the title text captured just before the modal opens.
    // Used to detect when new product content has replaced the old one.
    let previousTitle = null;

    // Capture the current title text before the modal starts loading new content.
    // This runs on 'show' (before 'shown'), so we get the stale/old title.
    $('#ModalquickView').on('show.bs.modal', function onModalShow() {
      const title = modal.querySelector('.tt-title');
      previousTitle = title ? title.innerText.trim() : null;
    });

    $('#ModalquickView').on('shown.bs.modal', function onModalShown() {
      if (typeof Weglot === 'undefined') return;

      const currentLang = Weglot.getCurrentLang();

      // Fix known incorrect translations of abbreviations/brand names
      function fixTranslation(text) {
        return text
          .replace(/\bCCP\b/g, 'KKP');
          // Add more replacements here if needed like this:
          // .replace(/\bWRONG1\b/g, 'CORRECT1')
          // .replace(/\bWRONG2\b/g, 'CORRECT2')
      }

      // Check if new product content has fully loaded into the modal.
      // Waits until title text has changed from the previous product
      // and is longer than 5 characters to avoid partial renders (e.g. "t").
      function isContentReady() {
        const title = modal.querySelector('.tt-title');
        if (!title) return false;
        const text = title.innerText.trim();
        if (text.length <= 5) return false;
        // If this is the first open, previousTitle is null — content is ready
        // If reopening, wait until title has actually changed to new product
        if (previousTitle === null) return true;
        return text !== previousTitle;
      }

      // Collect target elements, send to Weglot for translation,
      // then apply translated text back to the DOM.
      // Always reads from data-original-text if available, so switching
      // languages always translates from the original source text.
      function translateModal() {
        const title = modal.querySelector('.tt-title');
        const vendor = modal.querySelector('.qv_vendor');
        const type = modal.querySelector('.qv_type');

        const targets = [title, vendor, type].filter(el => el);

        // Save original text on first translation of each element.
        // On subsequent opens, always translate from the saved original.
        targets.forEach(function saveOriginalText(el) {
          const current = el.innerText.trim();
          if (!el.hasAttribute('data-original-text') || el.getAttribute('data-original-text') !== current) {
            el.setAttribute('data-original-text', current);
          }
        });

        const words = targets
          .map(el => ({ t: 1, w: el.getAttribute('data-original-text') }))
          .filter(w => w.w);

        if (words.length === 0) return;

        Weglot.translate(
          { words: words, languageTo: currentLang },
          function applyTranslations(data) {
            targets.forEach(function updateElement(el, i) {
              if (data[i]) el.innerText = fixTranslation(data[i]);
            });
          }
        );
      }

      // If new content is already loaded, translate immediately.
      // Otherwise, use MutationObserver to wait for new content before translating.
      if (isContentReady()) {
        translateModal();
        return;
      }

      const observer = new MutationObserver(function onMutation(mutations, obs) {
        if (isContentReady()) {
          obs.disconnect();
          translateModal();
        }
      });

      observer.observe(modal, { childList: true, subtree: true });
    });

};


function cartBackButtonFix() {

  // Refresh cart when page is shown (including back button navigation)
  window.addEventListener('pageshow', function pageLoadedEvent(event) {
    // Check if page is loaded from cache
    if (event.persisted) {
      // Trigger cart update handlers (without triggering modal)
      if (typeof addToCartHandler !== 'undefined' && addToCartHandler.updateGeneralInfo) {
        // Force cart refresh by calling update
        jQuery.get('/cart.js', function cartResponseHandler(cart) {
          addToCartHandler.updateGeneralInfo(cart);
          jQuery('body').trigger('refreshCurrency');
        });
      }
    }
  });
  
  // Also handle visibility change for additional safety
  document.addEventListener('visibilitychange', function visibilityChangeHandler() {
    if (!document.hidden) {
      if (typeof addToCartHandler !== 'undefined' && addToCartHandler.updateGeneralInfo) {
        jQuery.get('/cart.js', function cartResponseHandler(cart) {
          addToCartHandler.updateGeneralInfo(cart);
          jQuery('body').trigger('refreshCurrency');
        });
      }
    }
  });
}



